import { useContext } from "react";
import styles from "./styles/PosTransactionsPanel.module.css";
import DataContext from "../../../context/DataContext";
import useCurrencySymbol from "../../../hooks/useCurrencySymbol";
import { useTranslation } from "react-i18next";
import POSDataContext from "../../../context/POSDataContext";
import { axiosSW } from "../../../api/axiosDefaults";
import Spinner from "../../../components/ui/spinner/Spinner";
import PosSummaryTransaction from "../../../components/ui/pos_summary_transaction/PosSummaryTransaction";

/**
 * The transaction panel component
 */
const PosTransactionsPanel = ({
    setShowModal, // {Function} - Function to set the visibility of the info modal
    setCurrentTransaction, // {Function} - Function to set the current transaction (the one to be canceled)
}) => {
    const { t } = useTranslation();
    const { connection } = useContext(DataContext);
    const currency = useCurrencySymbol(true);
    const {
        isLoadingPos, // {Boolean} - Indicates if the data is loading in the POS module
        summaryPos, // {Object} - The summary data for POS
        setIsProcessingPos, // {Function} - Function to set the in process state in POS module
        handleErrorPos, // {Function} - Function to handle errors in POS

        setIsLoadingPos,
    } = useContext(POSDataContext);

    /**
     * delete transaction handler
     * initiate the cancelation process
     * 1- fetch the transaction info
     * 2- show info modal
     * @param {String} transactionNumber - {String} - The refernce number for the transaction to be canceled
     */
    const handleDelete = async (transactionNumber) => {
        const payLoad = {
            uniqueIdentifier: connection?.uniqueIdentifier,
            referenceNo: transactionNumber,
        };

        try {
            setIsProcessingPos(true);
            setIsLoadingPos(true);
            setShowModal(true);

            const { data } = await axiosSW.post(
                "Payment/pos/GetTransactionPaymentDetailsForRefund",
                payLoad,
            );

            if (data && data?.statusOk) {
                setCurrentTransaction(data);

                setIsProcessingPos(false);
                setIsLoadingPos(false);
            }
        } catch (error) {
            setIsProcessingPos(false);
            setIsLoadingPos(false);

            handleErrorPos(error);
        }
    };

    const allTransactions = summaryPos?.transactionPayments;
    return (
        <aside className={`${styles.summary_container} v-flex-container`}>
            <section
                className={`${styles.main_side_transactions_container} ${styles.stretch} v-flex-container`}
            >
                {isLoadingPos ? (
                    <Spinner />
                ) : !(allTransactions && allTransactions.length) ? (
                    <div
                        className={`${styles.transactions_message} flex-container`}
                    >
                        <h2>{t("no transactions available")}</h2>
                    </div>
                ) : (
                    <>
                        {allTransactions && allTransactions.length ? (
                            //_____________________________________________________________________________________Transactions

                            <>
                                <h4
                                    className={`${styles.tickets_label} flex-container`}
                                >
                                    {t(`transactions`)}
                                </h4>
                                <div
                                    className={`${styles.tickets_header} flex-container`}
                                >
                                    <span
                                        className={`${styles.header_entry} ${styles.transaction_tag}`}
                                    >
                                        {t("transaction")}
                                    </span>
                                    <span
                                        className={`${styles.header_entry}   ${styles.date_tag}`}
                                    >
                                        {t("date")}
                                    </span>
                                    <span
                                        className={`${styles.header_entry}  ${styles.time_tag}`}
                                    >
                                        {t("time")}
                                    </span>
                                    <span
                                        className={`${styles.header_entry} ${styles.amount_tag}`}
                                    >
                                        {t("amount")}
                                    </span>
                                </div>

                                {/* List all the transactions available */}
                                {allTransactions.map((item) => (
                                    <PosSummaryTransaction
                                        key={item?.referenceNo}
                                        transaction={item}
                                        currency={currency}
                                        // Each transaction has a button to cancel that specific transaction
                                        handleDelete={handleDelete}
                                    />
                                ))}
                            </>
                        ) : (
                            <></>
                        )}
                    </>
                )}
            </section>
        </aside>
    );
};

export default PosTransactionsPanel;
